module.exports = __webpack_public_path__ + "static/media/MobileSellerboxFunction03.4f1893f8.png";